import React, { useEffect } from 'react';
import { ButtonSecondary, cssColorValue, Text, semanticColors } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';
import analytics, { GA_CATEGORIES } from 'utils/client/analytics/analytics';
import { useUbiContactPage } from 'utils/ubi/pages/useUbiContact';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

import LegalText from '../LegalText';

const StyledType = styled(Text)`
  a {
    color: ${cssColorValue(semanticColors.textBrightAccent)};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const EmailContainer = () => {
  const ubi = useUbiContactPage();
  const { t, traw } = useTranslation();

  const {
    verticalConfig: {
      features: { supportEmail = '' },
    },
  } = useServerSideConstants();

  useEffect(() => {
    ubi.logEmailButtonLinkImpression();
    ubi.logEmailTextLinkImpression();
  }, [ubi]);

  const onEmailButtonClick = () => {
    analytics.trackEvent({ category: GA_CATEGORIES.CONTACT_FORM, action: 'email', label: 'open-email' });
    ubi.logEmailButtonLinkInteraction(supportEmail);
  };

  return (
    <>
      <Text as="h1" paddingBottom="0.75em" variant="titleMedium">
        {t('email_card_header')}
      </Text>
      <StyledType forwardedAs="p" variant="bodyMedium" paddingBottom="2em" data-testid="contact-body-1">
        {traw('email_card_body', { url: `mailto:${supportEmail}`, email: supportEmail })}
      </StyledType>

      <ButtonSecondary
        href={`mailto:${supportEmail}`}
        data-testid="submit-contact-form"
        onClick={onEmailButtonClick}
        target="_blank"
      >
        {t('email_card_cta')}
      </ButtonSecondary>
      <LegalText />
    </>
  );
};

export default EmailContainer;
